(function () {
  'use strict';

  // buy-buttons is shared by the product page and featured-product sections.
  if (window.HFProductOrigin) {
    window.HFProductOrigin.refresh();
    return;
  }

  var BADGE_SELECTOR = '[data-product-origin-badge]';
  var refreshScheduled = false;
  var observer;

  function parseEncodedOrigin(value) {
    if (typeof value !== 'string') return null;
    var match = value.trim().match(/^<([0-9]+)>\s*([^<>]+)$/);
    if (!match) return null;
    var country = match[2].trim();
    if (!country || country.toLowerCase() === 'default') return null;
    return { store: match[1], country: country };
  }

  function getCurrentPickingStore() {
    if (typeof window.getExplicitPickingStore !== 'function') return null;
    var store = String(window.getExplicitPickingStore() || '').trim();
    return /^[0-9]+$/.test(store) ? store : null;
  }

  function readOriginLocations(badge) {
    try {
      var values = JSON.parse(badge.getAttribute('data-origin-locations') || 'null');
      return Array.isArray(values) ? values : [];
    } catch (error) {
      return [];
    }
  }

  function getHighestPriceStores(badge) {
    var product = badge.closest('.product-item');
    if (!product) return [];
    var prices;
    try {
      prices = JSON.parse(product.getAttribute('data-location-prices') || 'null');
    } catch (error) {
      return [];
    }
    if (!prices || typeof prices !== 'object' || Array.isArray(prices)) return [];

    var highestPrice = 0;
    var stores = [];
    Object.keys(prices).forEach(function (store) {
      if (store === '1' || !/^[0-9]+$/.test(store)) return;
      var value = prices[store];
      if (typeof value !== 'number' && typeof value !== 'string') return;
      var rawPrice = String(value).trim();
      // Match highest-location-price.liquid: positive decimal, no partial parsing.
      if (!/^[0-9]+(?:\.[0-9]+)?$/.test(rawPrice)) return;
      var price = Number(rawPrice);
      if (!Number.isFinite(price) || price <= 0) return;
      if (price > highestPrice) {
        highestPrice = price;
        stores = [store];
      } else if (price === highestPrice) {
        stores.push(store);
      }
    });
    return stores;
  }

  function refresh() {
    var store = getCurrentPickingStore();
    document.querySelectorAll(BADGE_SELECTOR).forEach(function (badge) {
      var origins = readOriginLocations(badge).map(parseEncodedOrigin);
      // Browsing never selects a store. Only origins belonging to the highest
      // eligible price (excluding location 1) can appear; no cheaper-store fallback.
      var stores = store ? [store] : getHighestPriceStores(badge);
      var countries = [];
      stores.forEach(function (storeNumber) {
        var origin = origins.find(function (entry) {
          return entry && entry.store === storeNumber;
        });
        if (origin && countries.indexOf(origin.country) === -1) {
          countries.push(origin.country);
        }
      });
      var country = countries.join(', ');
      if (badge.textContent !== country) badge.textContent = country;
      if (badge.hidden !== !country) badge.hidden = !country;
    });
  }

  function scheduleRefresh() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    var schedule = window.requestAnimationFrame || function (callback) {
      return window.setTimeout(callback, 0);
    };
    schedule(function () {
      refreshScheduled = false;
      refresh();
    });
  }

  function containsBadge(node) {
    return node.nodeType === 1 &&
      (node.matches(BADGE_SELECTOR) || node.querySelector(BADGE_SELECTOR));
  }

  function initialize() {
    refresh();
    if (observer || !document.body || typeof MutationObserver === 'undefined') return;
    observer = new MutationObserver(function (records) {
      var needsRefresh = records.some(function (record) {
        if (record.type === 'attributes') {
          return record.attributeName === 'data-origin-locations'
            ? record.target.matches(BADGE_SELECTOR)
            : record.target.matches('.product-item') && containsBadge(record.target);
        }
        // Ignore badge text updates. Only inserted/replaced badge elements matter.
        return Array.from(record.addedNodes).some(containsBadge);
      });
      if (needsRefresh) scheduleRefresh();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-origin-locations', 'data-location-prices']
    });
  }

  document.addEventListener('locationChanged', scheduleRefresh);
  document.addEventListener('locationManagerReady', scheduleRefresh);
  document.addEventListener('shopify:section:load', scheduleRefresh);

  window.HFProductOrigin = {
    parseEncodedOrigin: parseEncodedOrigin,
    getCurrentPickingStore: getCurrentPickingStore,
    refresh: refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
